import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#06002e] relative  text-[#3a3380] bottom-0 z-10 w-full pt-3 pb-4 px-8 md:px-5  overflow-hidden">
      <div className="container mx-auto md:pl-20  md:py-8 flex flex-col md:flex-row items-start justify-between">
        {/* Mobile Navigation - Only visible on small screens */}
        <div className="md:hidden w-full mb-8">
          {/* <div className="bg-[#4d4d4d] rounded-lg p-4 mx-auto max-w-sm"> */}
          <div className="bg-[#4d4d4d] rounded-lg   mx-auto max-w-sm relative mt-8">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-full h-20 w-20 flex items-center justify-center  border-8 border-[#4d4d4d]">
              <img src="/images/new-logos/orange.png" alt="AIRCHECK Logo" className="h-10 w-auto object-contain" />
            </div>

            <div className="grid grid-cols-4 gap-4 text-center pl-2">
              <button
                className="text-white rounded-md text-xs font-medium p"
                onClick={() => (window.location.href = "/")}
              >
                <div className="flex flex-col items-center pt-2">
                  <img src="/images/icons/home.png" alt="Home" className="h-8 w-8 mb-1" />
                  <span className="text-xs">Home</span>
                </div>
              </button>
              <button
                className="text-white  rounded-md text-xs font-medium"
                onClick={() => (window.location.href = "/models")}
              >
                <div className="flex flex-col items-center pt-2 pr-6">
                  <img src="/images/icons/pipeline.png" alt="Home" className="h-10 w-10 mb-1" />
                  <span className="text-xs">Pipeline</span>
                </div>
              </button>
              <button
                className="text-white py-2 px-1 rounded-md text-xs font-medium"
                onClick={() => (window.location.href = "/datasets")}
              >
                <div className="flex flex-col items-center pl-4 pt-2">
                  <img src="/images/icons/download.svg" alt="Home" className="h-8 w-auto mb-1" />
                  <span className="text-xs">Datasets</span>
                </div>
              </button>
              <button
                className="text-white py-2 px-1 rounded-md text-xs font-medium"
                onClick={() => (window.location.href = "/profile")}
              >
                <div className="flex flex-col items-center pt-2">
                  <img src="/images/icons/profile.png" alt="Home" className="h-8 w-auto mb-1" />
                  <span className="text-xs">Profile</span>
                </div>
              </button>
              {/* <button className="bg-[#1e1a5a] text-white py-2 px-1 rounded-md text-xs font-medium">Profile</button> */}
            </div>
          </div>
        </div>

        {/* Left side content - 2/3 width (hidden on mobile) */}
        <div className="w-full md:w-2/3 flex flex-col md:flex-row items-center md:items-start gap-2">
          <div className="flex flex-col md:mr-8 items-center md:items-start text-left md:text-left">
            {/* Desktop logo - hidden on mobile */}
            <img
              src="/images/new-logos/new_aircheck_footer_logo.png"
              alt="AIRCHECK Logo"
              className="max-h-12 min-w-[120px] w-auto object-contain hidden md:block"
            />
            <p className="text-sm text-white leading-relaxed">
              AIRCHECK is developed and populated as a collaboration between the Structural Genomics Consortium,
              University Health Network, University of Toronto, University of North Carolina, X-Chem, and HitGen.
            </p>
          </div>
        </div>

        {/* Right side links - 1/3 width (hidden on mobile) */}
        <div className="w-full md:w-1/3  flex-col items-center mr-16 mt-8 md:mt-0 text-center md:text-center hidden md:flex">
          <h3 className="text-xl md:text-xl font-extralight text-white mb-2">
            <a href="/feedbackform" className="text-white hover:text-blue-200 transition duration-300">
              We Value Your Feedback
            </a>
          </h3>
          <p className="text-sm text-white">Help us improve our platform by sharing your thoughts and experience.</p>
        </div>
      </div>

      {/* Bottom bar - legal links */}
      <div className="container mx-auto md:pl-20  border-white/10">
        <div className="flex flex-col md:flex-row items-center justify-between mt-2 gap-3 text-sm text-white/70">
          <nav aria-label="Legal" className="flex items-center gap-4">
            <a
              href="/privacy-policy"
              className="text-white/80 hover:text-white transition duration-300 hover:underline underline-offset-4"
            >
              Privacy Policy
            </a>
            <button
              type="button"
              onClick={() => window.Cookiebot && window.Cookiebot.renew()}
              className="text-white/80 hover:text-white transition duration-300 hover:underline underline-offset-4 cursor-pointer bg-transparent border-0 p-0"
            >
              Cookie Settings
            </button>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

// import { useState, useMemo, useEffect, useCallback, useRef } from "react";

// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { Button } from "primereact/button";
// import { Tooltip } from "primereact/tooltip";
// import { Ripple } from "primereact/ripple";
// // import ChatWindow from "./components/ChatWindow";
// import ChatWindow from "../../../pages/chat/components/ChatWindow";

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: { retry: 1, refetchOnWindowFocus: false },
//     mutations: { retry: 0 },
//   },
// });

// // ── Constants ─────────────────────────────────────────────────────────────────
// const HEADER_H = 56; // px — header bar height
// const FAB_BOTTOM = 96; // px — popup bottom offset (sits above FAB)
// const MIN_W = 320; // px
// const MIN_H = 300; // px
// const SIDE_PAD = 28; // px — right/left margin

// // Derive sensible default popup size from current viewport
// function getDefaultSize() {
//   const vw = window.innerWidth;
//   const vh = window.innerHeight;
//   if (vw < 640) {
//     // Mobile: nearly full-width, 70 % height
//     return { w: vw - SIDE_PAD * 2, h: Math.min(vh * 0.7, 600) };
//   } else if (vw < 1024) {
//     // Tablet
//     return { w: 400, h: Math.min(vh * 0.65, 640) };
//   } else {
//     // Desktop+
//     return { w: 440, h: Math.min(vh * 0.74, 760) };
//   }
// }

// // ── Bot SVG Icon ──────────────────────────────────────────────────────────────
// const BotIcon = ({ size = 26 }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
//     <rect x="3" y="7" width="18" height="12" rx="3" fill="white" fillOpacity="0.95" />
//     <rect x="9" y="3" width="6" height="5" rx="1.5" fill="white" fillOpacity="0.75" />
//     <circle cx="9" cy="13" r="1.5" fill="#4f3fff" />
//     <circle cx="15" cy="13" r="1.5" fill="#4f3fff" />
//     <rect x="9" y="16" width="6" height="1.5" rx="0.75" fill="#4f3fff" fillOpacity="0.7" />
//     <line x1="7" y1="7" x2="7" y2="5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.65" />
//     <line x1="17" y1="7" x2="17" y2="5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.65" />
//     <circle cx="7" cy="4.5" r="1" fill="white" fillOpacity="0.65" />
//     <circle cx="17" cy="4.5" r="1" fill="white" fillOpacity="0.65" />
//   </svg>
// );

// // ── Resize Handle ─────────────────────────────────────────────────────────────
// // Thin invisible strip placed on an edge/corner. onDrag(dx, dy) receives raw delta.
// function ResizeHandle({ direction, onDrag }) {
//   const onMouseDown = useCallback(
//     (e) => {
//       e.preventDefault();
//       const startX = e.clientX;
//       const startY = e.clientY;
//       const onMove = (mv) => onDrag(mv.clientX - startX, mv.clientY - startY);
//       const onUp = () => {
//         window.removeEventListener("mousemove", onMove);
//         window.removeEventListener("mouseup", onUp);
//       };
//       window.addEventListener("mousemove", onMove);
//       window.addEventListener("mouseup", onUp);
//     },
//     [onDrag],
//   );

//   const base = { position: "absolute", zIndex: 10 };
//   const styles = {
//     top: { ...base, top: 0, left: 14, right: 14, height: 7, cursor: "n-resize" },
//     left: { ...base, top: 14, left: 0, bottom: 14, width: 7, cursor: "w-resize" },
//     topLeft: { ...base, top: 0, left: 0, width: 14, height: 14, cursor: "nw-resize" },
//     topRight: { ...base, top: 0, right: 0, width: 14, height: 14, cursor: "ne-resize" },
//   };

//   return <div onMouseDown={onMouseDown} style={styles[direction]} />;
// }

// // ── Chat Popup ────────────────────────────────────────────────────────────────
// function ChatPopup({ onClose }) {
//   const [minimized, setMinimized] = useState(false);
//   const [size, setSize] = useState(() => getDefaultSize());
//   const savedSize = useRef(null);
//   const manualResize = useRef(false);

//   const sessionId = useMemo(() => {
//     const stored = sessionStorage.getItem("chat_session_id");
//     if (stored) return stored;
//     const id = crypto.randomUUID();
//     sessionStorage.setItem("chat_session_id", id);
//     return id;
//   }, []);

//   // Re-fit on viewport resize unless user has manually dragged
//   useEffect(() => {
//     const handler = () => {
//       if (!manualResize.current) setSize(getDefaultSize());
//     };
//     window.addEventListener("resize", handler);
//     return () => window.removeEventListener("resize", handler);
//   }, []);

//   const clamp = useCallback(
//     (w, h) => ({
//       w: Math.max(MIN_W, Math.min(w, window.innerWidth - SIDE_PAD * 2)),
//       h: Math.max(MIN_H, Math.min(h, window.innerHeight - FAB_BOTTOM - HEADER_H - 24)),
//     }),
//     [],
//   );

//   // Returns a drag handler for the given growth directions (+1 / -1 / 0)
//   const resizer = (sx, sy) => (dx, dy) => {
//     manualResize.current = true;
//     setSize((s) => clamp(s.w + sx * dx, s.h + sy * dy));
//   };

//   const handleMinimise = () => {
//     if (!minimized) {
//       savedSize.current = size;
//       setMinimized(true);
//     } else {
//       if (savedSize.current) setSize(savedSize.current);
//       setMinimized(false);
//     }
//   };

//   const handleReset = () => {
//     manualResize.current = false;
//     setSize(getDefaultSize());
//     setMinimized(false);
//   };

//   return (
//     <div className="fixed z-[9999] flex flex-col" style={{ bottom: FAB_BOTTOM, right: SIDE_PAD, width: size.w }}>
//       {/* Drag handles — hidden while minimised */}
//       {!minimized && (
//         <>
//           <ResizeHandle direction="top" onDrag={resizer(0, -1)} />
//           <ResizeHandle direction="left" onDrag={resizer(-1, 0)} />
//           <ResizeHandle direction="topLeft" onDrag={resizer(-1, -1)} />
//           <ResizeHandle direction="topRight" onDrag={resizer(1, -1)} />
//         </>
//       )}

//       {/* ── Header ── */}
//       <div
//         className={`
//           flex items-center justify-between px-4 shrink-0
//           bg-gradient-to-br from-[#1a1060] to-[#06002e]
//           border border-white/10 select-none
//           transition-all duration-300
//           ${minimized ? "rounded-2xl shadow-2xl" : "rounded-t-2xl shadow-lg"}
//         `}
//         style={{ height: HEADER_H }}
//       >
//         {/* Avatar + title */}
//         <div className="flex items-center gap-3">
//           <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#7c6fff] to-[#4f3fff] flex items-center justify-center ring-2 ring-[#7c6fff]/30 shrink-0">
//             <BotIcon size={18} />
//           </div>
//           <div>
//             <p className="text-white font-semibold text-sm tracking-wide leading-none mb-1">AIRCHECK Assistant</p>
//             <div className="flex items-center gap-1.5">
//               <span className="w-2 h-2 rounded-full bg-green-400 shadow-[0_0_6px_#4ade80] animate-pulse" />
//               <span className="text-white/50 text-[11px]">Online</span>
//             </div>
//           </div>
//         </div>

//         {/* Controls */}
//         <div className="flex items-center gap-1">
//           <Tooltip target=".btn-reset-size" content="Reset to default size" position="top" />
//           <Button
//             icon="pi pi-window-maximize"
//             className="btn-reset-size p-ripple !w-8 !h-8 !rounded-lg !bg-white/10 hover:!bg-white/20 !border-0 !text-white/75 hover:!text-white !transition-all !duration-200"
//             onClick={handleReset}
//             text
//           >
//             <Ripple />
//           </Button>

//           <Tooltip target=".btn-minimise" content={minimized ? "Expand" : "Minimise"} position="top" />
//           <Button
//             icon={minimized ? "pi pi-chevron-up" : "pi pi-minus"}
//             className="btn-minimise p-ripple !w-8 !h-8 !rounded-lg !bg-white/10 hover:!bg-white/20 !border-0 !text-white/75 hover:!text-white !transition-all !duration-200"
//             onClick={handleMinimise}
//             text
//           >
//             <Ripple />
//           </Button>

//           <Tooltip target=".btn-close-chat" content="Close" position="top" />
//           <Button
//             icon="pi pi-times"
//             className="btn-close-chat p-ripple !w-8 !h-8 !rounded-lg !bg-white/10 hover:!bg-red-500/60 !border-0 !text-white/75 hover:!text-white !transition-all !duration-200"
//             onClick={onClose}
//             text
//           >
//             <Ripple />
//           </Button>
//         </div>
//       </div>

//       {/* ── Chat Body ── */}
//       <div
//         className="bg-gray-50 overflow-hidden rounded-b-2xl border border-t-0 border-[#06002e]/10 shadow-[0_16px_48px_rgba(6,0,46,0.3),0_2px_8px_rgba(0,0,0,0.1)]"
//         style={{
//           height: minimized ? 0 : size.h,
//           transition: "height 0.3s cubic-bezier(0.4,0,0.2,1)",
//           flexShrink: 0,
//         }}
//       >
//         {!minimized && (
//           <div className="w-full h-full animate-[slideUp_0.3s_cubic-bezier(0.4,0,0.2,1)]">
//             <QueryClientProvider client={queryClient}>
//               <ChatWindow sessionId={sessionId} />
//             </QueryClientProvider>
//           </div>
//         )}
//       </div>

//       {/* Resize hint badge */}
//       {!minimized && (
//         <div className="absolute bottom-2 right-2 pointer-events-none opacity-25 flex items-center gap-1">
//           <i className="pi pi-arrows-alt text-[#7c6fff] text-[10px]" />
//           <span className="text-[#7c6fff] text-[9px] tracking-wide">drag edges to resize</span>
//         </div>
//       )}
//     </div>
//   );
// }

// // ── Footer ────────────────────────────────────────────────────────────────────
// const Footer = () => {
//   const [chatOpen, setChatOpen] = useState(false);

//   return (
//     <>
//       <footer className="bg-[#06002e] relative text-[#3a3380] bottom-0 z-10 w-full pt-3 pb-4 px-8 md:px-5 overflow-hidden">
//         <div className="container mx-auto md:pl-20 md:py-8 flex flex-col md:flex-row items-start justify-between">
//           {/* Mobile Navigation */}
//           <div className="md:hidden w-full mb-8">
//             <div className="bg-[#4d4d4d] rounded-lg mx-auto max-w-sm relative mt-8">
//               <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-full h-20 w-20 flex items-center justify-center border-8 border-[#4d4d4d]">
//                 <img src="/images/new-logos/orange.png" alt="AIRCHECK Logo" className="h-10 w-auto object-contain" />
//               </div>
//               <div className="grid grid-cols-4 gap-4 text-center pl-2">
//                 {[
//                   { href: "/", icon: "/images/icons/home.png", label: "Home", cls: "h-8 w-8", wrap: "pt-2" },
//                   {
//                     href: "/models",
//                     icon: "/images/icons/pipeline.png",
//                     label: "Pipeline",
//                     cls: "h-10 w-10",
//                     wrap: "pt-2 pr-6",
//                   },
//                   {
//                     href: "/datasets",
//                     icon: "/images/icons/download.svg",
//                     label: "Datasets",
//                     cls: "h-8 w-auto",
//                     wrap: "pl-4 pt-2",
//                   },
//                   {
//                     href: "/profile",
//                     icon: "/images/icons/profile.png",
//                     label: "Profile",
//                     cls: "h-8 w-auto",
//                     wrap: "pt-2",
//                   },
//                 ].map(({ href, icon, label, cls, wrap }) => (
//                   <button
//                     key={label}
//                     className="text-white rounded-md text-xs font-medium"
//                     onClick={() => (window.location.href = href)}
//                   >
//                     <div className={`flex flex-col items-center ${wrap}`}>
//                       <img src={icon} alt={label} className={`${cls} mb-1`} />
//                       <span className="text-xs">{label}</span>
//                     </div>
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Left: logo + description */}
//           <div className="w-full md:w-2/3 flex flex-col md:flex-row items-center md:items-start gap-2">
//             <div className="flex flex-col md:mr-8 items-center md:items-start">
//               <img
//                 src="/images/new-logos/new_aircheck_footer_logo.png"
//                 alt="AIRCHECK Logo"
//                 className="max-h-12 min-w-[120px] w-auto object-contain hidden md:block"
//               />
//               <p className="text-sm text-white leading-relaxed">
//                 AIRCHECK is developed and populated as a collaboration between the Structural Genomics Consortium,
//                 University Health Network, University of Toronto, University of North Carolina, X-Chem, and HitGen.
//               </p>
//             </div>
//           </div>

//           {/* Right: feedback */}
//           <div className="w-full md:w-1/3 flex-col items-center mr-16 mt-8 md:mt-0 text-center hidden md:flex">
//             <h3 className="text-xl font-extralight text-white mb-2">
//               <a href="/feedbackform" className="text-white hover:text-blue-200 transition duration-300">
//                 We Value Your Feedback
//               </a>
//             </h3>
//             <p className="text-sm text-white">Help us improve our platform by sharing your thoughts and experience.</p>
//             <button
//               type="button"
//               onClick={() => window.Cookiebot && window.Cookiebot.renew()}
//               className="mt-3 text-sm text-white hover:text-blue-200 underline transition duration-300"
//             >
//               Change Cookie Settings
//             </button>
//           </div>

//           {/* Mobile: Cookie Settings link */}
//           <div className="md:hidden w-full text-center mt-4">
//             <button
//               type="button"
//               onClick={() => window.Cookiebot && window.Cookiebot.renew()}
//               className="text-sm text-white hover:text-blue-200 underline transition duration-300"
//             >
//               Change Cookie Settings
//             </button>
//           </div>
//         </div>
//       </footer>

//       {/* ── Floating Chat Button ── */}
//       <div className="fixed bottom-7 right-7 z-[9998]">
//         {!chatOpen && (
//           <span className="absolute inset-0 rounded-full bg-[#7c6fff]/30 animate-ping pointer-events-none" />
//         )}
//         <Tooltip target=".chat-fab" content="Chat with AIRCHECK Assistant" position="left" />
//         <Button
//           className={`chat-fab p-ripple !w-14 !h-14 !rounded-full !border-0 !transition-all !duration-300
//             ${
//               chatOpen
//                 ? "!bg-gradient-to-br !from-red-500 !to-red-700 !shadow-[0_4px_20px_rgba(220,53,69,0.5)]"
//                 : "!bg-gradient-to-br !from-[#7c6fff] !to-[#4f3fff] !shadow-[0_4px_20px_rgba(79,63,255,0.55)] hover:!shadow-[0_4px_28px_rgba(79,63,255,0.75)]"
//             }`}
//           onClick={() => setChatOpen((o) => !o)}
//         >
//           {chatOpen ? <i className="pi pi-times text-white text-xl" /> : <BotIcon size={26} />}
//           <Ripple />
//         </Button>
//       </div>

//       {/* ── Popup ── */}
//       {chatOpen && <ChatPopup onClose={() => setChatOpen(false)} />}

//       <style>{`
//         @keyframes slideUp {
//           from { opacity: 0; transform: translateY(10px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>
//     </>
//   );
// };

// export default Footer;
